import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/organization.svg
 */
const IconOrganization: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.726 22.619c.18.438.274.907.274 1.381h-7.211a3.612 3.612 0 012.226-3.334 3.603 3.603 0 014.71 1.953zm-3.332-2.228c1.326 0 2.4-1.075 2.4-2.402a2.401 2.401 0 10-2.4 2.402z"
      fill="currentColor"
    />
    <path
      d="M12 4.804c1.325 0 2.4-1.075 2.4-2.402A2.401 2.401 0 1012 4.804z"
      fill="currentColor"
    />
    <path
      d="M15.331 7.032c.181.438.275.907.275 1.381H8.394A3.612 3.612 0 0110.62 5.08a3.602 3.602 0 014.711 1.953z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.331 22.619c.181.438.275.907.275 1.381H8.394a3.612 3.612 0 012.226-3.334 3.602 3.602 0 014.711 1.953zM12 20.39c1.325 0 2.4-1.075 2.4-2.402A2.401 2.401 0 1012 20.39zM6.937 22.619c.181.438.274.907.274 1.381H0a3.612 3.612 0 012.226-3.334 3.602 3.602 0 014.71 1.953zM3.606 20.39c1.325 0 2.4-1.075 2.4-2.402a2.401 2.401 0 10-2.4 2.402z"
      fill="currentColor"
    />
    <path d="M11.5 8.413h1v8.004h-1V8.413z" fill="currentColor" />
    <path d="M20.895 11.915v1H3.105v-1h17.79z" fill="currentColor" />
    <path
      d="M3.105 12.004h1v4.283h-1v-4.283zM19.895 12.71h1v4.283h-1v-4.284z"
      fill="currentColor"
    />
  </svg>
);

export default IconOrganization;
